module.exports = __webpack_public_path__ + "img/01.2155b1f0.png";